export const riskTableDefaultSortBy = {
  defaultSortByColumn: [{ id: 'code', desc: false }],
};
